<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-layout>
          <v-flex>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex text-right>
            <v-btn @click="openNewTagDialog" depressed color="primary">
              Create New Tag
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="tagItems"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <div>
            {{ iMoment(item.createdAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <new-tag-dialog ref="newTagDialog" />
    <edit-tag-dialog :details="editedItem" ref="editTagDialog" />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewTagDialog from "../components/NewTagDialog";
import EditTagDialog from "../components/EditTagDialog";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  components: { NewTagDialog, EditTagDialog },
  data() {
    return {
      search: "",
      dialogDelete: false,
      itemToDelete: {
        name: "",
        latitude: "",
        longitude: "",
      },
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        // { text: "Font Family", value: "fontFamily" },
        // { text: "Font Name", value: "fontName" },
        // { text: "Background Color", value: "backgroundColor" },
        // { text: "Font Color", value: "fontColor" },
        { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedItem: {
        name: "",
        latitude: "",
        longitude: "",
      },
      editedIndex: -1,
      defaultItem: {
        name: "",
        latitude: "",
        longitude: "",
      },
    };
  },
  computed: {
    ...mapState("$_home", ["tagItems"]),
  },
  created() {
    if (this.tagItems.length === 0) {
      this.getTags({
        collection: "tags",
        mutation: "updateTags",
      });
    }
  },
  methods: {
    ...mapActions({
      getTags: "$_home/getContent",
      deleteTag: "$_home/deleteContent",
    }),
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format("lll");
      } else {
        return 0;
      }
    },
    openNewTagDialog() {
      this.$refs.newTagDialog.toggleDialog();
    },
    editItem(item) {
      this.editedIndex = this.tagItems.indexOf(item);
      this.editedItem = Object.assign({}, this.tagItems[this.editedIndex]);

      console.log("Edited Item: ", this.editedItem);

      this.$refs.editTagDialog.toggleDialog(this.editedItem);
    },
    deleteItem(item) {
      this.editedIndex = this.tagItems.indexOf(item);
      this.itemToDelete = Object.assign({}, this.tagItems[this.editedIndex]);
      this.dialogDelete = true;

      console.log(item);
    },
    deleteItemConfirm() {
      this.deleteTag({
        details: this.itemToDelete,
        collection: "tags",
        type: "Entity Type",
      }).then(() => {
        this.dialogDelete = false;
        this.getTags({
          collection: "tags",
          mutation: "updateTags",
        });
      });
    },
  },
};
</script>

<style>
</style>